if (!customElements.get('columns-slider')) {
  customElements.define(
    'columns-slider',
    class ColumnsWithImage extends HTMLElement {
      constructor() {
        super();

        this.flkty = null;
        this.gutter = 0;
        this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
      }

      connectedCallback() {
        this.checkSlidesSize();
        document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
      }

      initSlider() {
        this.classList.remove('carousel--inactive');

        this.flkty = new window.theme.Flickity(this, {
          pageDots: false,
          cellAlign: 'left',
          groupCells: true,
          contain: true,
          on: {
            ready: () => {
              this.setSliderArrowsPosition(this);
              setTimeout(() => {
                this.changeTabIndex();
                this.flkty.resize();
              }, 0);
            },
            change: () => {
              this.changeTabIndex();
            },
          },
        });

        this.createResizeClass();
      }

      createResizeClass() {
        if (typeof window.theme.Flickity.prototype._createResizeClass === 'function') return;

        window.theme.Flickity.prototype._createResizeClass = function () {
          this.element.classList.add('carousel--resize');
        };

        window.theme.Flickity.createMethods.push('_createResizeClass');

        const resize = window.theme.Flickity.prototype.resize;
        window.theme.Flickity.prototype.resize = function () {
          this.element.classList.remove('carousel--resize');
          resize.call(this);
          this.element.classList.add('carousel--resize');
        };
      }

      destroySlider() {
        this.classList.add('carousel--inactive');

        if (this.flkty !== null) {
          this.flkty.destroy();
          this.flkty = null;
        }
      }

      checkSlidesSize() {
        const sliderItemStyle = this.querySelector('[data-slider-item]').currentStyle || window.getComputedStyle(this.querySelector('[data-slider-item]'));
        this.gutter = parseInt(sliderItemStyle.marginRight);
        const containerWidth = this.offsetWidth;
        const itemsWidth = this.getItemsWidth();
        const itemsOverflowViewport = containerWidth < itemsWidth;

        if (window.innerWidth >= theme.sizes.small && itemsOverflowViewport) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      changeTabIndex() {
        const selectedElementsIndex = this.flkty.selectedIndex;

        this.flkty.slides.forEach((slide, index) => {
          slide.cells.forEach((cell) => {
            cell.element.querySelectorAll('a, button').forEach((link) => {
              link.setAttribute('tabindex', selectedElementsIndex === index ? '0' : '-1');
            });
          });
        });
      }

      getItemsWidth() {
        let itemsWidth = 0;
        const slides = this.querySelectorAll('[data-slider-item]');
        if (slides.length) {
          slides.forEach((item) => {
            itemsWidth += item.offsetWidth + this.gutter;
          });
        }

        return itemsWidth;
      }

      setSliderArrowsPosition(slider) {
        const arrows = slider.querySelectorAll('.flickity-button');
        const images = slider.querySelectorAll('[data-media-container]');

        // Find the tallest image
        let tallestImageHeight = 0;
        images.forEach((image) => {
          if (image.offsetHeight > tallestImageHeight) {
            tallestImageHeight = image.offsetHeight;
          }
        });

        if (arrows.length && tallestImageHeight > 0) {
          arrows.forEach((arrow) => {
            arrow.style.top = `${tallestImageHeight / 2}px`;
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
      }
    }
  );
}
